import type { ProductSearchRow } from '@plato/search/search-types';
import { SearchEntity } from '@plato/search/search-types';
import { SelectTriggerButton } from '@plato/ui-legacy/components/ui/select-trigger-button';
import Text from '@plato/ui-legacy/components/ui/text';
import { SearchIcon } from 'lucide-react';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { EntitySearchCombobox } from '../../shared/components/form-items-with-fetch/entity-search-combobox.tsx';

export type ProductSearchInputProps = {
    disabled?: boolean;
    onSelect: (value: ProductSearchRow) => void;
    draftId: string;
    customerId?: string;
};

export function ProductSearchInput({
    disabled,
    onSelect,
    draftId,
    customerId,
}: ProductSearchInputProps): ReactElement {
    const { t } = useTranslation();

    return (
        <EntitySearchCombobox
            className="w-full"
            disabled={disabled}
            entities={[SearchEntity.Product]}
            inputPlaceholder={t('search_product')}
            tracking={{
                context: 'draft_line_items',
                context_entity_type: 'draft',
                context_entity_id: draftId,
                customer_id: customerId,
            }}
            onValueChange={(values) => {
                const [item] = values;
                const { original } = item ?? {};

                if (original?.entity === SearchEntity.Product) {
                    onSelect(original);
                }
            }}
        >
            <SelectTriggerButton leftIcon={SearchIcon} rightIcon={null} disabled={disabled}>
                <Text className="w-full text-left" color="neutral-500">
                    {t('search_product')}
                </Text>
            </SelectTriggerButton>
        </EntitySearchCombobox>
    );
}
